import { SpinnerProps } from '@tymbe/components/indicators/spinner.types';

const Spinner = ({
  show = true,
  className = '',
  stroke = 'stroke-base-front-1',
}: SpinnerProps) => {
  return !show ? null : (
    <span
      className={`${className} inset-0 flex items-center justify-center rounded-3xl`}
    >
      <svg
        className={`animate-spin w-full h-full max-w-min max-h-min text-white ${stroke}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          strokeWidth="2"
          // This cuts off part of the circle
          strokeDasharray="60"
          strokeDashoffset="20"
        />
      </svg>
    </span>
  );
};

export default Spinner;
